import { Heading, Text, VStack } from 'native-base'
import { useEffect } from 'react'
import { useAuthContext } from '../../providers/AuthProvider'

const ResetPassword = ({ email }) => {
  const { resetPassword } = useAuthContext()
  const doResetPassword = () => resetPassword(email)

  useEffect(doResetPassword, [])

  return (
    <VStack h="100%" w="100%" style={{ gap: 12 }}>
      <Heading fontSize={'2xl'} mt="3" color="primary.900">
        Password reset
      </Heading>
      <Text color="primary.900" fontSize={'xl'} fontWeight={'semibold'}>
        {email}
      </Text>
      <Text color="primary.900" fontSize={'md'}>
        We've sent you an email to reset your password. Please click the link to
        continue.
      </Text>
    </VStack>
  )
}

export default ResetPassword
